import React from "react";
import CheveronUpIcon from "assets/icons/HeroIcons/CheveronUpIcon";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { sentenceCase, camelCase } from "change-case";
import useDateFormatter from "hooks/formatDateWithPattern";
import ellipsize from "ellipsize";

interface IProps {
  filter: any;
  dateFilter: any;
  reportSetting: any;
  repeatedDateFilter: any;
}

export const SummaryFiltering: React.FC<IProps> = ({
  filter,
  dateFilter,
  reportSetting,
  repeatedDateFilter,
}) => {
  const handleIconClick = (event: any) => {
    event.stopPropagation();
  };
  const { formatDate, FormatDateTime, formatTime } = useDateFormatter();

  const getFormattedValue = (el: any) => {
    if (!el?.value) {
      return null;
    }

    // Case 1: Array
    if (Array.isArray(el.value)) {
      return el.value.length > 0
        ? el.value.map((item: any) => item.text).join(", ")
        : null;
    }

    // Case 2: Plain string
    if (typeof el.value === "string") {
      // ✨ Apply ellipsize if input_type === "text"
      return el.inputType === "text" ? ellipsize(el.value, 50) : el.value;
    }

    // Case 3: Object with .value or .text
    const value = el.value?.value || el.value?.text;
    if (!value) {
      return null;
    }

    switch (el.type) {
      case "datetime-local":
        return FormatDateTime(value);
      case "time":
        return formatTime(value);
      case "date":
        return formatDate(value);
      default:
        return el.inputType === "text"
          ? ellipsize(el.value?.text || value, 30)
          : el.value?.text || value;
    }
  };

  return (
    <div className="pt-2 pb-4 border-b border-lineMid dark:border-lineLight">
      <Accordion
        className="dark:bg-secondaryLight "
        style={{ boxShadow: "none" }}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={<CheveronUpIcon height={16} width={16} fill="#2C3236" />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className="w-full" onClick={handleIconClick}>
            <div className="flex items-center justify-between w-full">
              <p className="text-secondaryMid dark:text-textMain ">Filtering</p>
            </div>
          </Typography>
        </AccordionSummary>
        <AccordionDetails style={{ marginTop: "-20px" }}>
          <Typography>
            <p className="text-sm text-secondaryMidLight dark:text-caption">
              Time Filter
            </p>
            {!reportSetting.isRepeat ? (
              dateFilter?.map((el: any, index: number) => {
                return (
                  <div
                    className="flex items-center justify-between py-2"
                    key={index}
                  >
                    <p className="text-sm mt-[-3px] dark:text-textMain">
                      {el.dateType === "observer_date"
                        ? "Submission Local Date"
                        : "Submission Date"}
                    </p>
                    <div className="flex">
                      <p className="text-sm mt-[-3px] ml-6 dark:text-caption">
                        {el?.condition}
                      </p>
                      <p className="text-sm mt-[-3px] ml-6 dark:text-textMain">
                        {index === 0
                          ? formatDate(el?.startDate)
                          : formatDate(el?.endDate)}
                      </p>
                    </div>
                  </div>
                );
              })
            ) : repeatedDateFilter?.periodType === "was_during_the_past" ? (
              <div className="flex items-center justify-between py-2">
                <p className="text-sm mt-[-3px] dark:text-textMain flex">
                  {repeatedDateFilter?.periodType === "was_during_the_past" &&
                    "Observation Date"}{" "}
                  ( {repeatedDateFilter?.period} )
                </p>
                <div className="flex">
                  <p className="text-sm mt-[-3px] ml-6 dark:text-textMain">
                    {repeatedDateFilter?.periodDuration}
                  </p>
                </div>
              </div>
            ) : (
              <div className="flex items-center justify-between py-2">
                <p className="text-sm mt-[-3px] dark:text-textMain">
                  {repeatedDateFilter?.date && "Observation Date"}
                </p>
                <div className="flex">
                  <p className="text-sm mt-[-3px] ml-6 dark:text-textMain">
                    {formatDate(repeatedDateFilter?.date)}
                  </p>
                </div>
              </div>
            )}
            <p
              className={`text-secondaryMidLight text-sm dark:text-caption ${dateFilter.length === 0 ? "mt-2" : ""}`}
            >
              Additional Filters
            </p>
            {filter?.map((el: any) => {
              return (
                <div className="flex items-center justify-between py-2">
                  <p className="text-sm mt-[-3px] dark:text-textMain">
                    {sentenceCase(camelCase(el?.column ?? ""))}
                  </p>
                  <div className="flex">
                    <p className="text-sm mt-[-3px] ml-6 dark:text-caption">
                      {el?.condition}
                    </p>
                    {getFormattedValue(el) && (
                      <p className="text-sm mt-[-3px] ml-6 dark:text-textMain">
                        {getFormattedValue(el)}
                      </p>
                    )}
                  </div>
                </div>
              );
            })}
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};
